/* eslint-disable no-undef */
/* eslint-disable import/prefer-default-export */
import Geocode from 'react-geocode';
import { store } from '../../redux/store';
import { setUserLocation } from '../../redux/actions/user';
import {getCurrentLocationCoordinates} from '../repos/graphql/locations';

Geocode.setApiKey(window.environment.REACT_APP_MAPS_API_KEY);
Geocode.setLanguage('en');
Geocode.setRegion('us');

let currentPositionResponse;

export const GeocodeInit = Geocode;

export const getMyAddressCoords = async (context, address) => {

  const response = await Geocode.fromAddress(address);

  const { lat, lng } = response.results[0].geometry.location;

  context.setState({
    myLocation: {
      lat,
      lng
    }
  });
};

export const handlePermissionDeniedGeoLocation = async (errResponse, callback, component) => {
  if (component === null) {
    callback(null, errResponse);
  }

  if(errResponse.code === errResponse.PERMISSION_DENIED && component !== null) {
    const res = await getCurrentLocationCoordinates();
    const { currentLocationCoordinates } = res.data;
    const { lat, lng } = currentLocationCoordinates;

    try {
      const response = await GeocodeInit.fromLatLng(lat, lng);
      callback(response);
    } catch (e) {
      callback(null, e);
    }
  }
};

/**
 * Reports the browser geolocation permission state without prompting the user.
 * Returns 'granted' | 'denied' | 'prompt', or 'unsupported' when the
 * Permissions API isn't available. Used by Find a Bakery (brand refresh) to
 * decide between re-prompting and falling back to a default location, since a
 * denied permission cannot be re-triggered programmatically from a click.
 */
export const getGeolocationPermissionState = async () => {
  try {
    if (
      window.navigator &&
      window.navigator.permissions &&
      window.navigator.permissions.query
    ) {
      const status = await window.navigator.permissions.query({
        name: 'geolocation',
      });
      return status.state;
    }
  } catch (e) {
    // Permissions API unavailable/unsupported — fall through to default
  }
  return 'unsupported';
};

const isValidLatLng = (latitude, longitude) =>
  typeof latitude === 'number'
  && typeof longitude === 'number'
  && Number.isFinite(latitude)
  && Number.isFinite(longitude)
  && Math.abs(latitude) <= 90
  && Math.abs(longitude) <= 180;

export const getCurrentPosition = (callback, component = null) => {

  const location = window.navigator && window.navigator.geolocation;
  const fetchCurrentPosition = (location && !currentPositionResponse);

  if (!(location && fetchCurrentPosition)) {
    return callback(currentPositionResponse);
  }

  location.getCurrentPosition(
    async position => {
      try {
        const { latitude, longitude } = (position && position.coords) || {};
        if (!isValidLatLng(latitude, longitude)) {
          callback(null, new Error('Provided coordinates are invalid'));
          return;
        }

        store.dispatch(setUserLocation({
          lat: latitude,
          lng: longitude
        }));

        const response = await GeocodeInit.fromLatLng(latitude, longitude);

        response.position = position;
        currentPositionResponse = response;

        callback(response);
      } catch (e) {
        callback(null, e);
      }
    },
    async err => handlePermissionDeniedGeoLocation(err, callback, component)
  );

  return null;
};
